import { render, staticRenderFns } from "./Emoji.vue?vue&type=template&id=11266e4c&"
import script from "./Emoji.vue?vue&type=script&setup=true&lang=js&"
export * from "./Emoji.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports